import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 1px 6px #00000029',
    fontSize: 14,
    padding: theme.spacing(1.5, 2),
    minWidth: 'max-content',
    maxWidth: 'fit-content',
    width: 'auto'
  },
  arrow: {
    color: theme.palette.common.white,
    fontSize: 16
  },
  popper: {
    pointerEvents: 'auto',
    zIndex: 1300
  }
}))(Tooltip);

export default LightTooltip;
